import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import Formulario, { FormField } from "../../../components/Formulario";
import { createFerramenta } from "../../../api/ferramentasApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdicionarFerramenta: React.FC = () => {
  const [nomeFerramenta, setNomeFerramenta] = useState<string>("");
  const [nomeTokenFerramenta, setNomeTokenFerramenta] = useState<string>("");
  const [habilidadeFerramenta, setHabilidadeFerramenta] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      const formData = new FormData();
      formData.append("nome_ferramenta", nomeFerramenta);
      formData.append("nome_token_ferramenta", nomeTokenFerramenta);
      formData.append("habilidade_ferramenta", habilidadeFerramenta);
      await createFerramenta(token, formData);
      toast.success("Ferramenta criada com sucesso!");
      navigate("/ferramenta");
    } catch (error) {
      toast.error("Erro ao adicionar ferramenta!");
      console.error("Erro ao adicionar ferramenta:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const fields: FormField[] = [
    {
      label: "Nome da Ferramenta",
      type: "text",
      value: nomeFerramenta,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeFerramenta(e.target.value),
    },
    {
      label: "Nome Token da Ferramenta",
      type: "text",
      value: nomeTokenFerramenta,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeTokenFerramenta(e.target.value),
    },
    {
      label: "Habilidade da Ferramenta",
      type: "text",
      value: habilidadeFerramenta,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setHabilidadeFerramenta(e.target.value),
    },
  ];

  return (
    <Formulario
      title="Adicionar Ferramenta"
      fields={fields}
      onSubmit={handleSubmit}
      loading={loading}
      onBack={handleBack}
    />
  );
};

export default AdicionarFerramenta;
